(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["@andbank-myinvestor/arq"] = factory(require("react"));
	else
		root["@andbank-myinvestor/arq"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__4639__) {
return 